/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceProposalAssociatedFeeType(name, id, weight) {
    this.name = name;
    this.id = id;
    this.weight = weight;
  }

  /*
   * Private Methods
   * --------------------------------------------------------------------------------
   */
  function checkAssetFinanceProposalAssociatedFeeType(id) {
    const index = _.findIndex(AssetFinanceProposalAssociatedFeeType.availableTypes, { id });
    return index !== -1;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAssociatedFeeType.Build = function (data) {
    if (!data || !data.id || !checkAssetFinanceProposalAssociatedFeeType(data.id)) {
      return new AssetFinanceProposalAssociatedFeeType(
        AssetFinanceProposalAssociatedFeeType.default.id.sanitize(),
        AssetFinanceProposalAssociatedFeeType.default.id,
        AssetFinanceProposalAssociatedFeeType.default.weight
      );
    }
    return new AssetFinanceProposalAssociatedFeeType(data.name, data.id, data.weight);
  };

  /*
   * Public properties
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAssociatedFeeType.default = { id: 'document_fee', weight: 1 };
  AssetFinanceProposalAssociatedFeeType.availableTypes = [
    { id: 'document_fee', weight: 1 },
    { id: 'ppsr', weight: 2 },
    { id: 'insurance', weight: 3 },
    { id: 'inspection_fee', weight: 4 },
    { id: 'valuation_fee', weight: 5 },
    { id: 'other_misc', weight: 6 },
    { id: 'monthly_fee', weight: 7 },
    { id: 'registration_fee', weight: 8 },
    { id: 'stamp_duty', weight: 9 }
  ];
  AssetFinanceProposalAssociatedFeeType.available = _.map(
    AssetFinanceProposalAssociatedFeeType.availableTypes,
    (assetFinanceProposalAssociatedFeeType) =>
      new AssetFinanceProposalAssociatedFeeType(
        assetFinanceProposalAssociatedFeeType.id.sanitize(),
        assetFinanceProposalAssociatedFeeType.id,
        assetFinanceProposalAssociatedFeeType.weight
      )
  );

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAssociatedFeeType.prototype.getName = function () {
    let { name } = this;
    if (this.id === AssetFinanceProposalAssociatedFeeType.availableTypes[1].id) {
      name = name.toUpperCase();
    }
    if (this.id === AssetFinanceProposalAssociatedFeeType.availableTypes[5].id) {
      const n = this.name.split(' ');
      name = `${n[0].capitalizeFirstLetter()}/${n[1].capitalizeFirstLetter()}`;
    }
    return name;
  };

  return AssetFinanceProposalAssociatedFeeType;
};
